
// 1. Select all video elements on the page
window.addEventListener('load', (event) => {
    const videos = document.querySelectorAll('video');

    // 2. Configure the observer
    const observerOptions = {
    root: null, // Uses the browser viewport as the container
    threshold: 0.25 // Triggers when 25% of the video is visible
    };

    // 3. Create the observer logic
    const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        const video = entry.target;
        
        if (entry.isIntersecting) {
        // Play the video if it enters the viewport
        video.play().catch(error => {
            // Autoplay policy might block audio; log it safely
            console.log("Autoplay prevented: ", error);
        });
        } else {
        // Pause the video if it leaves the viewport
        video.pause();
        }
        
    });
    }, observerOptions);

    // 4. Start tracking each video
    videos.forEach(video => videoObserver.observe(video));

    document.addEventListener('visibilitychange', () => {
    const videos = document.querySelectorAll('video');
    const video_wrappers = document.querySelectorAll('.video-wrapper');
    
    
    if (document.hidden) {
        // Pause all playing videos when user leaves the tab
        videos.forEach(video => video.pause());
        video_wrappers.forEach(video_wrapper => video_wrapper.classList.add('is-paused'));
    }
    });



    //ARTICLE PAGE CUSTOM ACCORDION
      document.querySelectorAll('.custom__accordion_button').forEach(button => {
        button.addEventListener('click', () => {
            button.classList.toggle('is-expanded');
            button.nextElementSibling.classList.toggle('is-expanded');
            
            
            const content = button.nextElementSibling;
            
            if (content.style.height === 'auto !important') {
                Object.assign(content.style, {
                    height: 0,
                    opacity: 0
                })

            } else {
                
                content.style.height = 'auto !important'
                // Object.assign(content.style, {
                //     height: 'auto !important',
                //     opacity: 1
                // })
                console.log(button.nextElementSibling);
            }
        });
        });


  

});
